<app-header></app-header>
<div class="main">
    <div class="container is-hcentered is-centered">
        <div class="imageContainer">
            <img src="assets/version2/logo_dark_word.svg" width="200">
        </div>
        <div class="rows">
            <div class="column">
                <button class="section-header button transparent-button" title="Patients click here"
                    [routerLink]="['/login/patient']">{{'LblPatientLogin'|translate}}</button>
            </div>
            <div class="column">
                <button class="section-header button transparent-button" title="Clinicians click here"
                    [routerLink]="['/login/clinician']">{{'LblClicianLogin'|translate}}</button>
            </div>
            <div class="column">
                <button class="section-header button transparent-button" title="Advisor / Consultant click here"
                    [routerLink]="['/login/consultant']">{{'LblConsultantLogin'|translate}}</button>
            </div>
            <!--        
                <div class="column">
                    <button class="section-header button transparent-button"
                        [routerLink]="['/login/admin']">{{'LblAdminLogin'|translate}}</button>
                </div>
        -->
        </div>
    </div>
</div>
<app-footer></app-footer>